/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Styles from './PartiuGpHeader.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

const PORTAL_CLIENTE_URL =
  'https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF';

const links = [
  { label: 'Início', href: '#partiu-gp-hero' },
  { label: 'Como participar', href: '#partiu-gp-como-participar' },
  { label: 'Prêmios', href: '#partiu-gp-premio' },
  { label: 'Aceleradores', href: '#partiu-gp-chances' },
  { label: 'Calendário', href: '#partiu-gp-calendario' },
  { label: 'Dúvidas frequentes', href: '#partiu-gp-faq' },
];

function PartiuGpHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeHref, setActiveHref] = useState(links[0].href);
  const headerRef = useRef(null);

  const getHeaderHeight = useCallback(
    () => (headerRef.current ? headerRef.current.offsetHeight : 0),
    [],
  );

  const scrollToSection = useCallback(
    (href) => {
      const target = document.querySelector(href);
      if (!target) return;
      const top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderHeight();
      window.scrollTo({ top, behavior: 'smooth' });
    },
    [getHeaderHeight],
  );

  const handleLinkClick = (ev, href) => {
    ev.preventDefault();
    setMenuOpen(false);
    scrollToSection(href);
  };

  useEffect(() => {
    const sections = links.map((link) => document.querySelector(link.href)).filter(Boolean);

    const handleScroll = () => {
      const scrollPos = window.scrollY + getHeaderHeight() + 8;
      let current = sections[0];
      sections.forEach((section) => {
        if (section.offsetTop <= scrollPos) {
          current = section;
        }
      });
      if (current) {
        setActiveHref(`#${current.id}`);
      }
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, [getHeaderHeight]);

  return (
    <header id="partiu-gp-header" ref={headerRef}>
      <ContainerHome24 className="header-inner">
        <a href="." className="header-logo">
          <picture>
            <source media="(min-width: 992px)" srcSet="static/amp/shared/assets/logo_reduced.svg" />
            <img src="static/amp/shared/assets/logo_reduced.svg" alt="Santander Financiamentos" />
          </picture>
        </a>

        <nav className="header-nav">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={activeHref === link.href ? 'active' : ''}
              onClick={(ev) => handleLinkClick(ev, link.href)}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="header-actions">
          <a href={PORTAL_CLIENTE_URL} target="_blank" rel="noopener" className="header-cta">
            <img
              src="assets/em-dia-vale-mais/shared/icon-area-cliente.svg"
              alt=""
              className="header-cta-icon"
            />
            Área do cliente
          </a>

          <button
            type="button"
            className="header-menu-btn"
            aria-label={menuOpen ? 'Fechar menu' : 'Abrir menu'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </ContainerHome24>

      <nav className={`header-mobile-nav ${menuOpen ? 'opened' : ''}`}>
        {links.map((link) => (
          <a
            key={link.href}
            href={link.href}
            className={activeHref === link.href ? 'active' : ''}
            onClick={(ev) => handleLinkClick(ev, link.href)}
          >
            {link.label}
          </a>
        ))}
      </nav>

      <style jsx>{Styles}</style>
    </header>
  );
}

export default PartiuGpHeader;
